import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/satoshi-400.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/satoshi-500.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/satoshi-700.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22fallback%22:[%22ui-sans-serif%22,%22system-ui%22,%22sans-serif%22]}],%22variableName%22:%22satoshi%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'satoshi', 'satoshi Fallback', ui-sans-serif, system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
